import 'ag-grid-community/styles/ag-theme-balham.css'
import 'ag-grid-community/styles/ag-grid.css'
import { AgGridReactProps } from 'ag-grid-react'

export const AgGridReact: React.ComponentType<AgGridReactProps> =
  process.env.NODE_ENV === 'test' ? require('ag-grid-react').AgGridReact : require('./AgGridLazy').AgGridLazy
